<div class="relative">
  <input type="text" [value]="term"
    (input)="onInput($any($event.target).value)"
    (keydown.enter)="onEnter($event)"
    (focus)="onFocus()"
    (blur)="close()"
    [disabled]="disabled"
    [placeholder]="placeholder"
    autocomplete="off"
    class="h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
    [class.border-gray-300]="value === null"
    [class.border-success-400]="value !== null"
    [class.bg-success-50]="value !== null" />

  @if (searching) {
    <div class="absolute right-3 top-3.5">
      <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-brand-500"></div>
    </div>
  } @else if (value !== null && allowClear) {
    <button type="button" (mousedown)="clear()" aria-label="Limpiar"
      class="absolute right-3 top-3 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
      </svg>
    </button>
  } @else if (value !== null) {
    <div class="absolute right-3 top-3.5 text-success-500">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
      </svg>
    </div>
  }

  <!--
    INC_CRM_020 (7) inc23/inc25 — antes el desplegable solo existía con resultados: una búsqueda
    sin coincidencias dejaba el campo mudo y era indistinguible de "sigue cargando". Ahora se
    abre igualmente para decirlo.
  -->
  @if (showDropdown && (results.length > 0 || noResults)) {
    <div
      class="absolute z-20 mt-1 w-full rounded-lg border border-gray-200 bg-white shadow-lg dark:border-gray-700 dark:bg-gray-900 max-h-56 overflow-y-auto"
      (scroll)="onScroll($event)">
      @if (noResults) {
        <p class="px-4 py-3 text-sm text-gray-500 dark:text-gray-400">Sin resultados</p>
      }
      @for (item of results; track idFn(item)) {
        <button type="button" (mousedown)="pick(item)"
          class="w-full px-4 py-2.5 text-left hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors">
          <span class="block text-sm font-medium text-gray-900 dark:text-white">{{ labelFn(item) }}</span>
          @if (sublabelFn(item)) {
            <span class="block text-xs text-gray-500 dark:text-gray-400">{{ sublabelFn(item) }}</span>
          }
        </button>
      }
      @if (loadingMore) {
        <div class="flex justify-center items-center py-2">
          <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-brand-500"></div>
          <span class="ml-2 text-xs text-gray-400 dark:text-gray-500">Cargando más...</span>
        </div>
      }
    </div>
  }
</div>
